import script from "./permission.vue?vue&type=script&setup=true&lang=js"
export * from "./permission.vue?vue&type=script&setup=true&lang=js"

import "./permission.vue?vue&type=style&index=0&id=fff0fbea&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff0fbea"]])

export default __exports__